/**
 * Nota de cupo de expedientes agotado (issue #568, frontend).
 *
 * La usan las tres entradas que crean expedientes — Radar, barra de
 * acciones en lote y dialogo de idea — en dos momentos:
 *
 * 1. **Antes de intentar** (`tono="aviso"`), cuando el plan ya reporta el
 *    cupo agotado. El texto lo compone `textoCupoAgotado()`
 *    (`lib/cupo-expedientes.ts`) a partir del limite real del plan, no de
 *    una constante del frontend.
 * 2. **Despues del 402** (`tono="error"`), con el `detail` del backend
 *    tal cual: `TierGate` ya cura ese copy (que paso + que hacer, ver
 *    CLAUDE.md "mensajes de error dicientes"), asi que repetirlo aca solo
 *    crearia dos versiones que se desincronizan.
 *
 * En los dos casos va el enlace a `/membresia`. Es lo que evita el
 * callejon sin salida: el usuario ve el mensaje donde esta parado y
 * puede revisar su plan sin perder lo que estaba haciendo.
 */

import { Link } from "react-router-dom";

export interface CupoExpedientesNotaProps {
  /** Texto a mostrar: el `detail` del backend, o `textoCupoAgotado()`. */
  mensaje: string;
  /**
   * `aviso` (default) para el bloqueo previo — informativo, el usuario
   * todavia no intento nada. `error` cuando ya llego un 402: es la
   * respuesta a una accion suya y va como `role="alert"`.
   */
  tono?: "aviso" | "error";
  className?: string;
}

export function CupoExpedientesNota({
  mensaje,
  tono = "aviso",
  className = "",
}: CupoExpedientesNotaProps) {
  const esError = tono === "error";
  const paleta = esError
    ? "border-red-200 bg-red-50 text-red-800"
    : "border-amber-200 bg-amber-50 text-amber-900";
  const enlace = esError
    ? "text-red-900 underline hover:text-red-700"
    : "text-amber-900 underline hover:text-amber-700";

  return (
    <div
      role={esError ? "alert" : "status"}
      data-testid="cupo-expedientes-nota"
      data-tono={tono}
      className={`rounded-lg border px-3 py-2 text-xs leading-relaxed ${paleta} ${className}`}
    >
      {mensaje}{" "}
      <Link to="/membresia" className={`font-semibold ${enlace}`}>
        Ver mi plan
      </Link>
    </div>
  );
}
